const initialState = {
  resultsGuestDirectoryList: [],
  resultsGuestDirectoryAdd: {},
  resultsGuestDirectoryPatch: {},
  resultsGuestDirectoryDelete: {},
  resultsGuestDirectoryFiles: [],
  resultsGuestDirectoryFileAdd: {},
  resultsGuestDirectoryFilePatch: {},
  resultsGuestDirectoryFileDelete: {},
  resultsGuestDirectoryImages: [],
  resultsGuestDirectoryImageAdd: {},
  resultsGuestDirectoryImagePatch: {},
  resultsGuestDirectoryImageDelete: {},
}

const reducer = (state = initialState, action) => {
  const newState = { ...state }

  switch (action.type) {
    case "LIST_GUEST_DIRECTORY_RESPONSE_GET":
      newState.resultsGuestDirectoryList = action.value
      break
    case "GUEST_DIRECTORY_RESPONSE_GET":
      newState.resultsGuestDirectory = action.value
      break
    case "GUEST_DIRECTORY_RESPONSE_ADD":
      newState.resultsGuestDirectoryAdd = action.value
      break
    case "GUEST_DIRECTORY_RESPONSE_UPDATE":
      newState.resultsGuestDirectoryPatch = action.value
      break
    case "GUEST_DIRECTORY_RESPONSE_DELETE":
      newState.resultsGuestDirectoryDelete = action.value
      break
    case "GUEST_DIRECTORY_FILES_RESPONSE_GET":
      newState.resultsGuestDirectoryFiles = action.value
      break
    case "GUEST_DIRECTORY_FILE_RESPONSE_ADD":
      newState.resultsGuestDirectoryFileAdd = action.value
      break
    case "GUEST_DIRECTORY_FILE_RESPONSE_UPDATE":
      newState.resultsGuestDirectoryFilePatch = action.value
      break
    case "GUEST_DIRECTORY_FILE_RESPONSE_DELETE":
      newState.resultsGuestDirectoryFileDelete = action.value
      break
    case "GUEST_DIRECTORY_IMAGES_RESPONSE_GET":
      newState.resultsGuestDirectoryImages = action.value
      break
    case "GUEST_DIRECTORY_IMAGE_RESPONSE_ADD":
      newState.resultsGuestDirectoryImageAdd = action.value
      break
    case "GUEST_DIRECTORY_IMAGE_RESPONSE_UPDATE":
      newState.resultsGuestDirectoryImagePatch = action.value
      break
    case "GUEST_DIRECTORY_IMAGE_RESPONSE_DELETE":
      newState.resultsGuestDirectoryImageDelete = action.value
      break
    case "RESET_GUEST_DIRECTORY_RESPONSES":
      newState.resultsGuestDirectoryAdd = {}
      newState.resultsGuestDirectoryPatch = {}
      newState.resultsGuestDirectoryDelete = {}
      newState.resultsGuestDirectoryFileAdd = {}
      newState.resultsGuestDirectoryFilePatch = {}
      newState.resultsGuestDirectoryFileDelete = {}
      newState.resultsGuestDirectoryImageAdd = {}
      newState.resultsGuestDirectoryImagePatch = {}
      newState.resultsGuestDirectoryImageDelete = {}
      newState.resultsGuestDirectory = {}
      break
    case "RESET_GUEST_DIRECTORY_RESPONSE":
      newState.resultsGuestDirectoryList = []
      break
    default:
      break
  }
  return newState
}

export default reducer
